import { Injectable, InjectionToken, inject } from '@angular/core';
import { VudYearMonthAdapter, VudYearMonthStruct } from '@vismaux/ngx-vud';

import { isInteger } from '#shared/helpers/is-integer.helper';

export interface VudYearMonthAdapterOptions {
  useLastDayOfMonth?: boolean;
}

export const VUD_YEAR_MONTH_ADAPTER_OPTIONS = new InjectionToken<VudYearMonthAdapterOptions>(
  'VUD_YEAR_MONTH_ADAPTER_OPTIONS',
);

@Injectable()
export class VudYearMonthNativeUtcAdapter extends VudYearMonthAdapter<Date> {
  private readonly options = inject(VUD_YEAR_MONTH_ADAPTER_OPTIONS, { optional: true });

  fromModel(dateString: Date | null): VudYearMonthStruct | null {
    if (dateString === null) {
      return null;
    }

    // Ensure its date
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date.getTime()) ? this._fromNativeDate(date) : null;
  }

  toModel(dateStruct: VudYearMonthStruct | null): Date | null {
    return dateStruct && isInteger(dateStruct.year) && isInteger(dateStruct.month)
      ? this._toNativeDate(dateStruct)
      : null;
  }

  today(): VudYearMonthStruct {
    return this._fromNativeDate(
      new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())),
    );
  }

  protected _fromNativeDate(date: Date): VudYearMonthStruct {
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
    };
  }

  protected _toNativeDate(date: VudYearMonthStruct): Date {
    if (this.options?.useLastDayOfMonth) {
      const lastDayDate = new Date(Date.UTC(date.year, date.month, 0));
      // avoid 30 -> 1930 conversion
      lastDayDate.setUTCFullYear(date.year);
      return lastDayDate;
    }

    const jsDate = new Date(Date.UTC(date.year, date.month - 1, 1));
    // avoid 30 -> 1930 conversion
    jsDate.setUTCFullYear(date.year);
    return jsDate;
  }
}
